import firebase from "firebase/app";
import "firebase/firestore";
import { Log } from "features/shared/types/info";

import { AppThunk } from "services/redux/rootReducer";
import { LogAction } from "../types/actions";

const getAllLogs = (): AppThunk<() => void> => (dispatch) => {
    const unsubscribe = firebase
        .firestore()
        .collection("logs")
        .onSnapshot((querySnapshot) => {
            const logs: Array<Log> = [];
            querySnapshot.forEach((doc: firebase.firestore.DocumentData) => {
                logs.push(doc.data());
            });
            dispatch({
                type: LogAction.SET_LOGS,
                logs,
            });
        });

    return unsubscribe;
};

export default getAllLogs;
